import React from 'react';
import {DesktopTimePicker} from '@mui/x-date-pickers/DesktopTimePicker';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import "pages/Styles/UIKit_v2.sass";

type Props = {
    entity: any;
    currentTime: string;
    onTimeChange: (time: string) => void;
}

export const TimePickerField: React.FC<Props> = ({entity, currentTime, onTimeChange}) => {
    if (entity.type !== "Дата" || !entity.includeTime) {
        return null;
    }

    // Создаем dayjs объект для TimePicker
    const timeValue = dayjs(`2000-01-01T${currentTime}`);

    return (
        <div style={{marginTop: "10px"}}>
            <div style={{marginBottom: "5px", display: 'flex', alignItems: 'center', gap: '8px'}}>
                <span className="commonLabel">Время</span>
            </div>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <div className="entity-date-time-picker-v2">
                <DesktopTimePicker
                    value={timeValue}
                    onChange={(newValue) => {
                        if (!newValue) return;
                        
                        const newTime = newValue.format('HH:mm');
                        
                        // Просто передаем время в callback
                        onTimeChange(newTime);
                    }}
                    ampm={false}
                    format="HH:mm"
                    slotProps={{
                        openPickerButton: { tabIndex: -1 },
                        textField: {
                            size: "small",
                            sx: { width: "100%" },
                        }
                    }}
                />
                </div>
            </LocalizationProvider>
        </div>
    );
};
